import { defineStore } from 'pinia'
import { store } from '@admin/store'
import { queryLangOption } from '@admin/api/common/lang/index'

export const useLangStore = defineStore('app-lang', () => {
  const langOptionGroups = ref({})

  const getLangOptionGroups = async () => {
    const { data } = await queryLangOption()
    langOptionGroups.value = data
  }

  // C端多语言选项
  const customerOptions = computed(() => langOptionGroups.value['customer'])
  // C端多语言值
  const customerLangValues = computed(() => customerOptions.value.map((option) => option.value))

  // B端多语言选项
  const businessOptions = computed(() => langOptionGroups.value['business'])
  // B端多语言值
  const businessLangValues = computed(() => businessOptions.value.map((option) => option.value))

  return {
    customerOptions,
    customerLangValues,
    businessOptions,
    businessLangValues,
    langOptionGroups,
    getLangOptionGroups,
  }
})

// Need to be used outside the setup
export function useLangStoreWithOut() {
  return useLangStore(store)
}
